module.exports =[
    {
      path: '/',
      name: 'index',
      component:resolve => require(['@/components/index.vue'], resolve),
      meta: {
        title: "耐火材料、耐火原料、 耐火设备、冶金炉料第三届中国（宜兴）耐火原料国际交易洽谈会首页",
        content:{
          keywords: "耐火材料、宜兴耐火原料展会、耐火设备、冶金炉料",
          description: "推动宜兴及周边耐火材料企业发展，提升宜兴在中国乃至国际耐火材料市场的影响力；提升宜兴耐火行业企业市场、供应链竞争力，降本增效；加速宜兴耐火材料企业数字化转型升级。"
        }

      }
    },
    {
      path: '/introduce',
      name: 'exintroduce',
      component: resolve => require(['@/components/introduce.vue'], resolve),
      meta: {
         title: "铝矾土、棕刚玉、中国耐火、银耐联_大会介绍",
        content:{
          keywords: "铝矾土、棕刚玉、耐火材料、江苏宜兴、银耐联",
          description: "大会旨在推动宜兴及周边耐火材料企业发展，提升宜兴在中国乃至国际耐火材料市场的影响力、供应链竞争力；加速宜兴耐火材料企业数字化转型升级。"
        }
      }
    },
    {
      path: '/forum',
      name: 'forum',
      component: resolve => require(['@/components/forum.vue'], resolve),
      meta: {
         title: "耐火材料、耐火原料、耐火材料会议_同期活动",
        content:{
          keywords: "耐火材料、耐材原料、耐材会议论坛、 发布会",
          description: "本栏目主要介绍关于第第三届中国（宜兴）耐火原料国际交易洽谈会的耐火材料会议、耐材企业发展论坛以及耐材企业转型升级研讨会等同期举办的活动"
        }
      }
    },
    {
      path: '/forumdetails',
      name: 'forumdetails',
      component: resolve => require(['@/components/forumdetails.vue'], resolve),
      meta: {
        title: "耐火材料、耐火原料、耐火材料会议_同期活动详情",
        content:{
          keywords: "耐火材料、耐材原料、耐材会议论坛、 发布会",
          description: "本栏目主要介绍关于第第三届中国（宜兴）耐火原料国际交易洽谈会的耐火材料会议、耐材企业发展论坛以及耐材企业转型升级研讨会等同期举办的活动"
        }
      }
    },
    {
      path: '/enterprise',
      name: 'enterprise',
      component: resolve => require(['@/components/enterprise.vue'], resolve),
      meta: {
        title: "铝矾土、白刚玉、增碳剂、耐材制品展会_参展企业",
        content:{
          keywords: "增碳剂、白刚玉、耐材制品、参展企业",
          description: "冶金炉料，耐材制品，耐火原料，装备及数字化企业以及对增碳剂、碳粉等产品的参展企业线上展览，耐材企业展厅和产品介绍。"
        }
      }
    },
    {
      path: '/specimens',
      name: 'specimens',
      component: resolve => require(['@/components/specimens.vue'], resolve),
      meta: {
         title: "铝矾土、增碳剂、棕刚玉、江苏宜兴_大会集锦",
        content:{
          keywords: "铝矾土会议、棕刚玉、耐火材料论坛、江苏宜兴",
          description: "此栏目是第三届中国（宜兴）耐火原料国际交易洽谈会的照片及视频回顾，包含照片集锦、会议、论坛等同期活动的精彩瞬间。以及展览现场耐火材料企业。智能装备制造企业的风采。"
        }
      }
    },
    {
      path: '/dynamic',
      name: 'dynamic',
      component: resolve => require(['@/components/dynamic.vue'], resolve),
      meta: {
        title: "耐火材料、耐火原料、智能装备制造 宜兴_大会动态",
        content:{
          keywords: "耐火材料、耐火原料、展会信息、耐材之窗 ",
          description: "耐材之窗全程对此次会议会进行独家报道，耐火材料、耐火原料新鲜展会信息就在大会动态栏目。"
        }
      }
    },
    {
      path: '/dynamicdetails',
      name: 'dynamicdetails',
      component: resolve => require(['@/components/dynamicdetails.vue'], resolve),
      meta: {
         title: "耐火材料、耐火原料、耐火设备、江苏宜兴_媒体聚焦",
        content:{
          keywords: "耐火材料、耐材展会、耐材参会资讯、媒体报道",
          description: "本栏目会收集关于第三届中国（宜兴）耐火原料国际交易洽谈会的参会资讯媒体报道，网站用户可在本页面查找阅读。多家媒体报道将会汇聚于此，欢迎您关注此栏目，了解媒体对宜兴耐火材料大会的报道视角。"
        }
      }
    },
    {
      path: '/information',
      name: 'information',
      component: resolve => require(['@/components/information.vue'], resolve),
      meta: {
        title: "资料下载"
      }
    },
    {
      path: '/associatedMedia',
      name: 'associatedMedia',
      component: resolve => require(['@/components/associatedMedia.vue'], resolve),
      meta: {
        title: "合作媒体"
      }
    },
    {
      path: '/floorplan',
      name: 'floorplan',
      component: resolve => require(['@/components/floorplan.vue'], resolve),
      meta: {
        title: "耐火材料、耐火原料、耐火设备_展位图",
        content:{
          keywords: "耐火材料展位图、耐火设备、耐材制品洽谈区、江苏宜兴",
          description: "第三届中国（宜兴）耐火原料国际交易洽谈会参会参展企业可以从展位图查看，展位分为标展和洽谈桌，展位现场设有展架摆放区域。"
        }
      }
    },
    {
      path: '/csshi',
      name: 'ceshi',
      component: resolve => require(['@/components/floorplan.vue'], resolve),
      meta: {
        title: "测试"
      }
    },
    {
      path: '/mediaFocus',
      name: 'mediaFocus',
      component: resolve => require(['@/components/mediaFocus.vue'], resolve),
      meta: {
         title: "铝矾土 刚玉 展会 江苏宜兴_第三届中国（宜兴）耐火原料国际交易洽谈会大会服务",
        content:{
          keywords: "大会服务、参展路线、铝矾土、刚玉、展会",
          description: "欢迎各位耐火原料客商，希望您能拥有愉快的参展体验，栏目包含参展联系方式、会场交通以及其它参展注意事项。"
        }
      }
    },
 
    {
      path: '/contactus',
      name: 'contactus',
      component:resolve => require(['@/components/contactus.vue'], resolve), 
      meta: {
        title: "联系我们"
      }
    },
    {
      path:'*',
      name:'404',
      meta: {
        title: "404"
      },
      component: resolve => require(['@/components/load404.vue'], resolve) 
    }
  ]
